<template>
  <v-menu bottom left offset-y max-width="768">
    <button class="dt-button v5 s22p" slot="activator">
      <img
        src="static/icons/options/options-blue.svg"
        alt="options"
        class="dt-icon s18p"
      />
    </button>
    <v-list class="filter-more-options-list">
      <v-list-tile
        class="options-item"
        v-for="(item, index) in options"
        :key="index"
        @click="(e) => $emit('click', item)"
      >
        <v-list-tile-title
          :class="{
            'ut-text-error': item.error ? true : false,
          }"
          >{{ item.text }}</v-list-tile-title
        >
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: ["options"],
};
</script>